/* JeahMy thema — minimale, afhankelijkheidsvrije interacties */
(function () {
  'use strict';

  function on(sel, evt, fn, root) {
    (root || document).querySelectorAll(sel).forEach(function (el) { el.addEventListener(evt, fn); });
  }

  on('[data-menu-toggle]', 'click', function () {
    var nav = document.querySelector('[data-drawer-nav]');
    if (nav) nav.classList.toggle('is-open');
  });

  on('[data-search-toggle]', 'click', function () {
    var box = document.querySelector('[data-search-box]');
    if (!box) return;
    box.hidden = !box.hidden;
    if (!box.hidden) { var i = box.querySelector('input'); if (i) i.focus(); }
  });

  on('[data-tab]', 'click', function (e) {
    var btn = e.currentTarget;
    var group = btn.closest('[data-tabs]');
    if (!group) return;
    group.querySelectorAll('[data-tab]').forEach(function (b) { b.setAttribute('aria-selected', String(b === btn)); });
    group.querySelectorAll('[data-tabpanel]').forEach(function (p) { p.hidden = p.dataset.tabpanel !== btn.dataset.tab; });
  });

  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-hero-track]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    if (!track || !dots.length) return;
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, n) { d.setAttribute('aria-current', String(n === i)); });
    }, { passive: true });
  });

  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main] img');
    on('[data-gallery-thumb]', 'click', function (e) {
      var btn = e.currentTarget;
      var img = btn.querySelector('img');
      if (main && img) { main.src = img.dataset.large || img.src; main.alt = img.alt; }
      gal.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    }, gal);
  });

  function openDrawer() {
    var d = document.querySelector('[data-cart-drawer]');
    if (!d) return false;
    d.hidden = false;
    document.body.classList.add('is-locked');
    refreshDrawer();
    return true;
  }
  function closeDrawer() {
    var d = document.querySelector('[data-cart-drawer]');
    if (!d) return;
    d.hidden = true;
    document.body.classList.remove('is-locked');
  }
  on('[data-cart-open]', 'click', function (e) { if (openDrawer()) e.preventDefault(); });
  on('[data-cart-close]', 'click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'nl', {
      style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
    }).format(cents / 100);
  }

  function refreshDrawer() {
    var body = document.querySelector('[data-cart-items]');
    if (!body) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = document.querySelector('[data-cart-count]');
        if (count) count.textContent = cart.item_count;
        var total = document.querySelector('[data-cart-total]');
        if (total) total.textContent = money(cart.total_price);

        var bar = document.querySelector('[data-ship-bar]');
        if (bar) {
          var threshold = parseInt(bar.dataset.threshold || '0', 10) * 100;
          var fill = bar.querySelector('[data-ship-fill]');
          var text = bar.querySelector('[data-ship-text]');
          if (threshold > 0) {
            var pct = Math.min(100, (cart.total_price / threshold) * 100);
            if (fill) fill.style.width = pct + '%';
            if (text) {
              text.textContent = cart.total_price >= threshold
                ? (bar.dataset.reached || '')
                : (bar.dataset.progress || '').replace('__AMOUNT__', money(threshold - cart.total_price));
            }
          }
        }

        if (!cart.items.length) {
          body.innerHTML = '<p class="empty-note">' + (body.dataset.empty || '') + '</p>';
          return;
        }
        body.innerHTML = cart.items.map(function (item) {
          return '<div class="drawer-item">' +
            '<div class="drawer-item__media">' + (item.image ? '<img src="' + item.image + '&width=160" alt="" width="74" height="74">' : '') + '</div>' +
            '<div><a href="' + item.url + '">' + item.product_title + '</a>' +
            (item.variant_title ? '<div class="card__type">' + item.variant_title + '</div>' : '') +
            '<div class="price"><span class="price__current">' + money(item.final_line_price) + '</span></div>' +
            '<div class="card__type">' + item.quantity + 'x</div></div></div>';
        }).join('');
      })
      .catch(function () {});
  }

  on('[data-product-form]', 'submit', function (e) {
    var form = e.currentTarget;
    if (!document.querySelector('[data-cart-drawer]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function () { openDrawer(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  refreshDrawer();
})();
